import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { provideAdditionalAssignmentApi } from '../../api/services/additional-assignment.service';
import { provideAssignmentApi } from '../../api/services/assignment.service';
import { provideCareerApi } from '../../api/services/career.service';
import { provideCategoryApi } from '../../api/services/categories.service';
import { provideClientApi } from '../../api/services/client.api';
import { provideContactApi } from '../../api/services/contact.service';
import { provideDisabilityProofApi } from '../../api/services/disability-proof.service';
import { provideDisabilityTypeApi } from '../../api/services/disability-type.api';
import { provideGenderApi } from '../../api/services/gender.api';
import { provideImpedimentApi } from '../../api/services/impediment.service';
import {
	INSTITUTION_PERSON_SERVICE,
	InstitutionPersonService,
	provideInstitutionPersonService,
} from '../../api/services/institution-person.service';
import { INSTITUTION_SERVICE, InstitutionService, provideInstitutionApi } from '../../api/services/institution.service';
import {
	INTEGRATION_OFFICE_SERVICE,
	IntegrationServiceOfficeService,
	provideIsoApi,
} from '../../api/services/integration-office.service';
import { provideLegalFoundationApi } from '../../api/services/legal-foundation.service';
import { provideLekApi } from '../../api/services/lek.service';
import { providePositionShareApi } from '../../api/services/position-share.service';
import { provideReportApi } from '../../api/services/report.service';
import { ROLE_SERVICE, RoleService } from '../../api/services/role.service';
import { provideServiceOfficeStatementApi } from '../../api/services/service-office-statement.service';
import { SPECIALIZATION_SERVICE, SpecializationService } from '../../api/services/specialization.service';
import { provideSponsorApi } from '../../api/services/sponsor.service';
import { provideUploadApi } from '../../api/services/upload.api';
import { provideUserApi, USER_SERVICE, UserApi } from '../../api/services/user.service';
import { provideValidationApi } from '../../api/services/validation.service';
import { WORKPLACE_SERVICE, WorkplaceService } from '../../api/services/workplace.api';
import { DefaultLayout } from '../../core/layouts/default-layout/default-layout';
import { provideState } from '../../core/services/state.service';
import { Admin } from '../../features/admin/admin';
import { AdditionalAssignmentMove } from '../../features/assignment-move/additional-assignment-move/additional-assignment-move';
import { AssignmentMove } from '../../features/assignment-move/assignment-move/assignment-move';
import { FdsAssignmentMove } from '../../features/assignment-move/fds-assignment-move/fds-assignment-move';
import { LvrAdmissionQbReport } from '../../features/client/admission-qb-report/admission-qb-report';
import { AdditionalAssignmentDetails } from '../../features/client/client-assignments/additional-assignment/additional-assignment-details/additional-assignment-details';
import { AdditionalAssignmentEdit } from '../../features/client/client-assignments/additional-assignment/additional-assignment-edit/additional-assignment-edit';
import { CreateAdditionalAssignment } from '../../features/client/client-assignments/additional-assignment/create-additional-assignment/create-additional-assignment';
import { AssignmentEdit } from '../../features/client/client-assignments/assignment-edit/assignment-edit';
import { AssignmentView } from '../../features/client/client-assignments/assignment-view/assignment-view';
import { CreateLek } from '../../features/client/client-assignments/client-lek/create-lek/create-lek';
import { DetailLek } from '../../features/client/client-assignments/client-lek/detail-lek/detail-lek';
import { EditLek } from '../../features/client/client-assignments/client-lek/edit-lek/edit-lek';
import { CreateAssignment } from '../../features/client/client-assignments/create-assignment/create-assignment';
import { CreateFdsAssignment } from '../../features/client/client-assignments/create-fds-assignment/create-fds-assignment';
import { FdsAssignmentDetails } from '../../features/client/client-assignments/fds-assignment-details/fds-assignment-details';
import { FdsAssignmentEdit } from '../../features/client/client-assignments/fds-assignment-edit/fds-assignment-edit';
import { FdsAssignmentTemplate } from '../../features/client/client-assignments/fds-assignment-template/fds-assignment-template';
import { CareerCreate } from '../../features/client/client-career/career-create/career-create';
import { CareerDetail } from '../../features/client/client-career/career-detail/career-detail';
import { CareerEdit } from '../../features/client/client-career/career-edit/career-edit';
import { ClientCareer } from '../../features/client/client-career/client-career';
import { ClientDetails } from '../../features/client/client-details/client-details';
import { ClientDisabilities } from '../../features/client/client-disabilities/client-disabilities';
import { CreateDisabilityType } from '../../features/client/client-disabilities/create-disability-type/create-disability-type';
import { DisabilityProofCreate } from '../../features/client/client-disabilities/disability-proof-create/disability-proof-create';
import { DisabilityProofDetail } from '../../features/client/client-disabilities/disability-proof-detail/disability-proof-detail';
import { DisabilityProofEdit } from '../../features/client/client-disabilities/disability-proof-edit/disability-proof-edit';
import { DisabilityTypeEdit } from '../../features/client/client-disabilities/disability-type-edit/disability-type-edit';
import { DisabilityTypeItemDetails } from '../../features/client/client-disabilities/disability-type-item-details/disability-type-item-details';
import { LvrTemplateEditorView } from '../../features/client/client-documents/common-template-viewer/common-template-view';
import { LvrDocumentViewer } from '../../features/client/client-documents/document-viewer/document-viewer';
import { DocumentsView } from '../../features/client/client-documents/documents-view/documents-view';
import { ClientRelatives } from '../../features/client/client-relatives/client-relatives';
import { ClientRelativesCreate } from '../../features/client/client-relatives/client-relatives-create/client-relatives-create';
import { ClientRelativesDetail } from '../../features/client/client-relatives/client-relatives-detail/client-relatives-detail';
import { ClientRelativesEdit } from '../../features/client/client-relatives/client-relatives-edit/client-relatives-edit';
import { CreateClient } from '../../features/client/create-client/create-client';
import { LvrEndQbReport } from '../../features/client/end-qb-report/end-qb-report';
import { LvrEndReport } from '../../features/client/end-report/end-report';
import { LvrImpedimentReport } from '../../features/client/impediment-report/impediment-report';
import { LvrStartReport } from '../../features/client/start-report/start-report';
import { ContactDetails } from '../../features/contact/contact-details/contact-details';
import { ContactEdit } from '../../features/contact/contact-edit/contact-edit';
import { ContactView } from '../../features/contact/contact-view/contact-view';
import { CreateContact } from '../../features/contact/create-contact/create-contact';
import { Dashboard } from '../../features/dashboard/dashboard';
import { Database } from '../../features/database/database';
import { Desk } from '../../features/desk/desk';
import { ErrorPage } from '../../features/error/error';
import { InstitutionCreate } from '../../features/institution/institution-create/institution-create';
import { InstitutionDetails } from '../../features/institution/institution-details/institution-details';
import { InstitutionDetailsEdit } from '../../features/institution/institution-details/institution-details-edit/institution-details-edit';
import { InstitutionPersonCreate } from '../../features/institution/institution-person-create/institution-person-create';
import { InstitutionPersonDetails } from '../../features/institution/institution-person-details/institution-person-details';
import { InstitutionPersonEdit } from '../../features/institution/institution-person-edit/institution-person-edit';
import { InstitutionPersons } from '../../features/institution/institution-persons/institution-persons';
import { InstitutionWorkplaceDetails } from '../../features/institution/institution-workplace/institution-workplace-details/institution-workplace-details';
import { InstitutionWorkplaceEdit } from '../../features/institution/institution-workplace/institution-workplace-edit/institution-workplace-edit';
import { WorkplaceCreate } from '../../features/institution/institution-workplace/workplace-create/workplace-create';
import { WorkplaceView } from '../../features/institution/institution-workplace/workplace-view/workplace-view';
import { IsoDetails } from '../../features/integration-service-office/iso-details/iso-details';
import { NetworkContactCreate } from '../../features/network-contact/network-contact-create/network-contact-create';
import { NetworkContactDetails } from '../../features/network-contact/network-contact-details/network-contact-details';
import { NetworkContactEdit } from '../../features/network-contact/network-contact-edit/network-contact-edit';
import { SpecialistRepresentation } from '../../features/specialist/specialist-representation/specialist-representation';
import { SponsorDetails } from '../../features/sponsor/sponsor-details/sponsor-details';
import { SponsorPersonCreate } from '../../features/sponsor/sponsor-person-create/sponsor-person-create';
import { SponsorPersonDetails } from '../../features/sponsor/sponsor-person-details/sponsor-person-details';
import { SponsorPersons } from '../../features/sponsor/sponsor-persons/sponsor-persons';
import { Status } from '../../features/status/status';
import { AdminUser } from '../../features/user/admin-user/admin-user';
import { AdminUserEdit } from '../../features/user/admin-user/admin-user-edit/admin-user-edit';
import { SpecialistDetails } from '../../features/user/specialist-details/specialist-details';
import { UserAssignmentTransfer } from '../../features/user/user-assignment-transfer/user-assignment-transfer';
import { UserCreate } from '../../features/user/user-create/user-create';
import { UserDetailsEdit } from '../../features/user/user-details-edit/user-details-edit';
import { UserDetails } from '../../features/user/user-details/user-details';
import { UserList } from '../../features/user/user-list/user-list';
import { additionalAssignmentEnabledGuard } from '../guards/additional-assignment-enabled.guard.fn';
import { lvrPermissionGuard } from '../guards/permission-guard.fn';
import { restrictedClientGuard } from '../guards/restricted-client.guard.fn';
import { NOTIFICATION_SERVICE } from '../notification/notification';
import { NotificationService } from '../notification/notification.service';
import { RecordType } from '../record/types';
import {
	activeAssignmentResolver,
	assignmentChangeResolver,
	assignmentResolver,
	assignmentsResolver,
	assignmentWithMetadataResolver,
	dateRangeResolverDueToDate,
	endOfCaresResolver,
	typeOfCareIdByAssignmentResolver,
} from './resolvers/assignment.resolver';
import {
	careerPageResolver,
	careerResolver,
	participationStatusResolver,
	socialSecurityStatusResolver,
} from './resolvers/career.resolver';
import {
	caseGroupsResolver,
	categoryPersonCategoriesResolver,
	contactPointCategoriesResolver,
	contactTypesResolver,
	countiesResolver,
	lekCategoriesResolver,
	personTypeInstitutionsResolver,
	personTypesResolver,
	typesOfCareResolver,
} from './resolvers/category.resolver';
import { clientNameResolver, clientResolver, dashboardItemsResolver } from './resolvers/client.resolver';
import {
	contactResolver,
	contactsResolver,
	dashboardContactsResolver,
	networkContactDocumentEntryResolver,
	networkContactResolver,
	validContactDateRangeResolver,
} from './resolvers/contact.resolver';
import {
	disabilityKindNeighborsResolver,
	disabilityKindResolver,
	disabilityKindsResolver,
	disabilityTypesResolver,
} from './resolvers/disability-type.resolver';
import {
	disabilityProofNeighborsResolver,
	disabilityProofResolver,
	disabilityProofsResolver,
	disabilityStatusResolver,
	latestDisabilityReportResolver,
} from './resolvers/disability.resolver';
import { clientDocumentsResolver, documentResolver } from './resolvers/documents.resolver';
import { genderResolver } from './resolvers/gender.resolver';
import { allImpedimentAsGroupsResolver, impedimentsOfReportResolver } from './resolvers/impediment.resolver';
import {
	institutionPersonNeighborsResolver,
	institutionPersonResolver,
	institutionPersonsResolver,
} from './resolvers/institution-person.resolver';
import { BranchesResolver, institutionEditResolver, institutionResolver } from './resolvers/institution.resolver';
import { integrationOfficeResolver, integrationOfficesResolver } from './resolvers/integration-office.resolver';
import { lekResolver, leksForAssignmentResolver, lekSponsorResolver } from './resolvers/lek.resolver';
import { relativeNeighborsResolver, relativeResolver, relativesResolver } from './resolvers/relatives.resolver';
import {
	assignmentHasUnfinishedReportsResolver,
	documentTemplatesResolver,
	reportOfAssignment,
	reportsOfAssignmentResolver,
} from './resolvers/report.resolver';
import { rolesResolver } from './resolvers/roles.resolver';
import { specializationResolver } from './resolvers/specialization.resolver';
import {
	sponsorByIdResolver,
	sponsorPersonNeighborsResolver,
	sponsorPersonResolver,
	sponsorPersonsResolver,
} from './resolvers/sponsor.resolver';
import { userByIdResolver, userClientsResolver, userResolver, usersResolver } from './resolvers/user.resolver';
import {
	institutionAndWorkplaceEditResolver,
	institutionWorkplaceNeighborsResolver,
	institutionWorkplaceResolver,
	institutionWorkplacesResolver,
} from './resolvers/workplace.resolver';
import { catchErrorOfResolve } from './resolvers/wrap-resolve-error.func';

// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export const ROUTES: { [key: string]: Routes } = {
	dashboard: [
		{
			path: '',
			component: DefaultLayout,
			title: `${environment.titlePrefix}Dashboard`,
			canActivate: [MsalGuard],
			children: [
				{
					path: '',
					component: Dashboard,
					canActivate: [lvrPermissionGuard(['Dashboard.Clients.Read', 'Dashboard.Fachkraefte.Read'])],
					resolve: {
						items: dashboardItemsResolver, // Clients or users
						contacts: dashboardContactsResolver,
					},
					providers: [provideClientApi, provideInstitutionApi, provideCategoryApi, provideContactApi],
				},
				{
					path: 'error',
					component: ErrorPage,
				},
				{
					path: 'user-settings',
					component: UserDetails,
					resolve: {
						user: userResolver,
						genders: genderResolver,
					},
					providers: [
						{
							provide: USER_SERVICE,
							useClass: UserApi,
						},
						provideGenderApi,
					],
					canActivate: [],
				},
				{
					path: 'user-settings/edit',
					component: UserDetailsEdit,
					resolve: {
						user: catchErrorOfResolve(userResolver),
						genders: catchErrorOfResolve(genderResolver),
						contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
					},
					canActivate: [
						lvrPermissionGuard([
							'Users.PositionShares.Read.Own',
							'Users.PositionShares.Read',
							'Users.PositionShares.Edit',
							'Users.Substitutes.Read.Own',
							'Users.Substitutes.Read',
							'Users.Substitutes.Edit',
						]),
					],
					providers: [
						{
							provide: USER_SERVICE,
							useClass: UserApi,
						},
						provideGenderApi,
						{
							provide: NOTIFICATION_SERVICE,
							useClass: NotificationService,
						},
						provideCategoryApi,
					],
				},
			],
		},
	],
	database: [
		{
			path: 'database',
			component: DefaultLayout,
			title: `${environment.titlePrefix}Datenbank`,
			canActivate: [MsalGuard],
			children: [{ path: '', component: Database }],
		},
	],
	wiki: [
		{
			path: 'wiki',
			component: DefaultLayout,
			title: 'Status',
			canActivate: [MsalGuard],
			children: [{ path: '', component: Status }],
		},
	],
	desk: [
		{
			path: 'desk',
			component: DefaultLayout,
			title: `${environment.titlePrefix}desk`,
			canActivate: [MsalGuard],
			children: [
				{
					path: '',
					component: Desk,
					title: `${environment.titlePrefix}desk`,
					canActivate: [MsalGuard],
					canActivateChild: [restrictedClientGuard],
					providers: [provideClientApi, provideAssignmentApi, provideState, provideUserApi, provideValidationApi],
					children: [
						{
							path: 'user/:id/representation',
							component: SpecialistRepresentation,
							data: {
								recordType: RecordType.USER,
							},
							providers: [provideUserApi],
						},
						{
							path: 'user/:id',
							loadComponent: () => SpecialistDetails,
							data: {
								recordType: RecordType.USER,
							},
							resolve: {
								user: catchErrorOfResolve(userByIdResolver),
								genders: catchErrorOfResolve(genderResolver),
							},
							providers: [provideUserApi, provideGenderApi, provideValidationApi, providePositionShareApi],
						},
						{
							path: 'user/:id/assignments/move',
							loadComponent: () => UserAssignmentTransfer,
							canActivate: [lvrPermissionGuard('Assignments.Reassign')],
							data: {
								recordType: RecordType.USER,
							},
							resolve: {
								user: catchErrorOfResolve(userByIdResolver),
								clients: catchErrorOfResolve(userClientsResolver),
							},
							providers: [provideUserApi, provideValidationApi, provideUserApi],
						},
						{
							path: 'specialist/:id/representation',
							component: SpecialistRepresentation,
							data: {
								recordType: RecordType.SPECIALIST_REPRESENTATION,
							},
						},
						{
							path: 'network-contact/add',
							loadComponent: () => NetworkContactCreate,
							canActivate: [lvrPermissionGuard('Contacts.Create')],
							data: {
								recordType: RecordType.CREATE_NETWORK_CONTACT,
							},
							resolve: {
								contactTypes: catchErrorOfResolve(contactTypesResolver),
								user: catchErrorOfResolve(userResolver),
							},
							providers: [provideContactApi, provideUserApi, provideCategoryApi, provideUploadApi],
						},
						{
							path: 'network-contact/:contactId',
							loadComponent: () => NetworkContactDetails,
							data: {
								recordType: RecordType.NETWORK_CONTACT,
							},
							resolve: {
								contactTypes: catchErrorOfResolve(contactTypesResolver),
								user: catchErrorOfResolve(userResolver),
								contact: catchErrorOfResolve(networkContactResolver),
								contacts: catchErrorOfResolve(dashboardContactsResolver),
							},
							providers: [provideContactApi, provideUserApi, provideCategoryApi, provideUploadApi],
						},
						{
							path: 'network-contact/:contactId/documents/:documentId',
							loadComponent: () => LvrDocumentViewer,
							canActivate: [lvrPermissionGuard('Documents.Contact.Read')],
							resolve: {
								document: catchErrorOfResolve(documentResolver),
								documents: catchErrorOfResolve(networkContactDocumentEntryResolver),
							},
							providers: [provideUploadApi, provideContactApi],
						},
						{
							path: 'network-contact/:contactId/edit',
							loadComponent: () => NetworkContactEdit,
							data: {
								recordType: RecordType.NETWORK_CONTACT,
							},
							resolve: {
								contactTypes: catchErrorOfResolve(contactTypesResolver),
								user: catchErrorOfResolve(userResolver),
								contact: catchErrorOfResolve(networkContactResolver),
							},
							providers: [provideContactApi, provideUserApi, provideCategoryApi, provideUploadApi],
						},
						{
							path: 'sponsor/:id',
							component: SponsorDetails,
							data: {
								recordType: RecordType.SPONSOR,
							},
							canActivate: [lvrPermissionGuard('Sponsors.Read')],
							resolve: {
								sponsor: catchErrorOfResolve(sponsorByIdResolver),
							},
							providers: [provideSponsorApi],
						},
						{
							path: 'sponsor/:id/persons',
							component: SponsorPersons,
							data: {
								recordType: RecordType.SPONSOR_PERSONS,
							},
							canActivate: [lvrPermissionGuard('Sponsors.Read')],
							resolve: {
								sponsor: catchErrorOfResolve(sponsorByIdResolver),
								sponsorPersons: catchErrorOfResolve(sponsorPersonsResolver),
							},
							providers: [provideSponsorApi],
						},
						{
							path: 'sponsor/:id/persons/add',
							component: SponsorPersonCreate,
							data: {
								recordType: RecordType.CREATE_SPONSOR_PERSON,
							},
							canActivate: [lvrPermissionGuard('InstitutionPersons.Create')],
							resolve: {
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
								genders: catchErrorOfResolve(genderResolver),
							},
							providers: [provideSponsorApi, provideCategoryApi, provideGenderApi],
						},
						{
							path: 'sponsor/:id/persons/:personId',
							loadComponent: () => SponsorPersonDetails,
							data: {
								recordType: RecordType.SPONSOR_PERSONS,
							},
							canActivate: [lvrPermissionGuard('InstitutionPersons.Read')],
							resolve: {
								sponsor: catchErrorOfResolve(sponsorByIdResolver),
								person: catchErrorOfResolve(sponsorPersonResolver),
								personNeighbors: catchErrorOfResolve(sponsorPersonNeighborsResolver),
							},
							providers: [provideSponsorApi],
						},
						{
							path: 'sponsor/:id/persons/:personId/edit',
							component: SponsorPersonCreate,
							data: {
								recordType: RecordType.SPONSOR_PERSONS,
							},
							canActivate: [lvrPermissionGuard('InstitutionPersons.Edit')],
							resolve: {
								sponsor: catchErrorOfResolve(sponsorByIdResolver),
								person: catchErrorOfResolve(sponsorPersonResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
								genders: catchErrorOfResolve(genderResolver),
							},
							providers: [provideSponsorApi, provideCategoryApi, provideGenderApi],
						},
						{
							path: 'integration-service-office/:id',
							loadComponent: () => IsoDetails,
							data: {
								recordType: RecordType.INTEGRATION_OFFICE_SERVICE,
							},
							resolve: {
								iso: catchErrorOfResolve(integrationOfficeResolver),
							},
							providers: [provideIsoApi],
						},
						{
							path: 'institution/add',
							component: InstitutionCreate,
							data: {
								recordType: RecordType.CREATE_INSTITUTION,
							},
							canActivate: [lvrPermissionGuard('Institutions.Create')],
							resolve: {
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [provideCategoryApi],
						},
						{
							path: 'institution/:id',
							component: InstitutionDetails,
							data: {
								recordType: RecordType.INSTITUTION,
							},
							canActivate: [lvrPermissionGuard('Institutions.Read')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								workplaces: catchErrorOfResolve(institutionWorkplacesResolver),
								persons: catchErrorOfResolve(institutionPersonsResolver),
								contactPointTypes: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [
								{
									provide: INSTITUTION_SERVICE,
									useClass: InstitutionService,
								},
								provideCategoryApi,
								{
									provide: WORKPLACE_SERVICE,
									useClass: WorkplaceService,
								},
								{
									provide: INSTITUTION_PERSON_SERVICE,
									useClass: InstitutionPersonService,
								},
							],
						},
						{
							path: 'institution/:id/persons',
							component: InstitutionPersons,
							data: {
								recordType: RecordType.INSTITUTION_PERSONS,
							},
							canActivate: [lvrPermissionGuard('InstitutionPersons.Read')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								persons: catchErrorOfResolve(institutionPersonsResolver),
								contactPointTypes: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [
								{
									provide: INSTITUTION_SERVICE,
									useClass: InstitutionService,
								},
								{
									provide: INSTITUTION_PERSON_SERVICE,
									useClass: InstitutionPersonService,
								},
								provideCategoryApi,
							],
						},
						{
							path: 'institution/:id/edit',
							component: InstitutionDetailsEdit,
							data: {
								recordType: RecordType.INSTITUTION,
							},
							canActivate: [lvrPermissionGuard('Institutions.Edit')],
							resolve: {
								institution: catchErrorOfResolve(institutionEditResolver),
								contactPointTypes: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [
								{
									provide: INSTITUTION_SERVICE,
									useClass: InstitutionService,
								},
								provideCategoryApi,
							],
						},
						{
							path: 'institution/:id/persons/add',
							component: InstitutionPersonCreate,
							data: {
								recordType: RecordType.CREATE_INSTITUTION_PERSON,
							},
							canActivate: [lvrPermissionGuard('InstitutionPersons.Create')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								personTypes: catchErrorOfResolve(personTypesResolver),
								genders: catchErrorOfResolve(genderResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
								branches: catchErrorOfResolve(BranchesResolver),
							},
							providers: [provideInstitutionApi, provideCategoryApi, provideGenderApi],
						},
						{
							path: 'institution/:id/persons/:personId',
							loadComponent: () => InstitutionPersonDetails,
							data: {
								recordType: RecordType.INSTITUTION_PERSONS,
							},
							canActivate: [lvrPermissionGuard('InstitutionPersons.Read')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								person: catchErrorOfResolve(institutionPersonResolver),
								personNeighbors: catchErrorOfResolve(institutionPersonNeighborsResolver),
							},
							providers: [provideInstitutionPersonService, provideInstitutionApi],
						},
						{
							path: 'institution/:id/persons/:personId/edit',
							loadComponent: () => InstitutionPersonEdit,
							data: {
								recordType: RecordType.INSTITUTION_PERSONS,
							},
							canActivate: [lvrPermissionGuard('InstitutionPersons.Edit')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								person: catchErrorOfResolve(institutionPersonResolver),
								personTypes: catchErrorOfResolve(personTypesResolver),
								genders: catchErrorOfResolve(genderResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [provideInstitutionPersonService, provideInstitutionApi, provideCategoryApi, provideGenderApi],
						},
						{
							path: 'institution/:id/workplace',
							component: WorkplaceView,
							data: {
								recordType: RecordType.INSTITUTION_WORKPLACE,
							},
							canActivate: [lvrPermissionGuard('Institutions.Read')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								workplace: catchErrorOfResolve(institutionWorkplacesResolver),
								user: catchErrorOfResolve(userResolver),
							},
							providers: [
								{
									provide: INSTITUTION_SERVICE,
									useClass: InstitutionService,
								},
								{
									provide: WORKPLACE_SERVICE,
									useClass: WorkplaceService,
								},
								provideUserApi,
							],
						},
						{
							path: 'institution/:id/workplace/add',
							component: WorkplaceCreate,
							data: {
								recordType: RecordType.CREATE_INSTITUTION_WORKPLACE,
							},
							canActivate: [lvrPermissionGuard('Institutions.Edit')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
								user: catchErrorOfResolve(userResolver),
							},
							providers: [
								{
									provide: WORKPLACE_SERVICE,
									useClass: WorkplaceService,
								},
								{
									provide: INSTITUTION_SERVICE,
									useClass: InstitutionService,
								},
								provideCategoryApi,
								provideUserApi,
							],
						},
						{
							path: 'institution/:id/workplace/:branchId',
							component: InstitutionWorkplaceDetails,
							data: {
								recordType: RecordType.INSTITUTION_WORKPLACE,
							},
							canActivate: [lvrPermissionGuard('Institutions.Read')],
							resolve: {
								institution: catchErrorOfResolve(institutionResolver),
								workplace: catchErrorOfResolve(institutionWorkplaceResolver),
								workplaceNeighbors: catchErrorOfResolve(institutionWorkplaceNeighborsResolver),
								user: catchErrorOfResolve(userResolver),
							},
							providers: [
								{
									provide: INSTITUTION_SERVICE,
									useClass: InstitutionService,
								},
								{
									provide: WORKPLACE_SERVICE,
									useClass: WorkplaceService,
								},
								provideUserApi,
							],
						},
						{
							path: 'institution/:id/workplace/:branchId/edit',
							component: InstitutionWorkplaceEdit,
							data: {
								recordType: RecordType.INSTITUTION_WORKPLACE,
							},
							canActivate: [lvrPermissionGuard('Institutions.Edit')],
							resolve: {
								institutionAndWorkplace: catchErrorOfResolve(institutionAndWorkplaceEditResolver),
								user: catchErrorOfResolve(userResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [
								{
									provide: INSTITUTION_SERVICE,
									useClass: InstitutionService,
								},
								{
									provide: WORKPLACE_SERVICE,
									useClass: WorkplaceService,
								},
								provideUserApi,
								provideCategoryApi,
							],
						},
						{
							path: 'client/add',
							component: CreateClient,
							data: {
								recordType: RecordType.CREATE_CLIENT,
							},
							canActivate: [lvrPermissionGuard(['Clients.Create', 'Clients.Create.PhaseOneOnly'])],
							resolve: {
								genders: catchErrorOfResolve(genderResolver),
								counties: catchErrorOfResolve(countiesResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [provideGenderApi, provideCategoryApi],
						},
						{
							path: 'client/:id',
							component: ClientDetails,
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								counties: catchErrorOfResolve(countiesResolver),
								user: catchErrorOfResolve(userResolver),
							},
							canActivate: [
								lvrPermissionGuard(['Clients.Read', 'Clients.Read.Restricted', 'Clients.Read.PhaseOneOnly']),
							],
							data: {
								recordType: RecordType.CLIENT,
								editMode: false,
							},
							providers: [provideCategoryApi, provideUploadApi, provideUserApi],
						},
						{
							path: 'client/:id/edit',
							component: ClientDetails,
							data: {
								recordType: RecordType.CLIENT,
								editMode: true,
							},
							canActivate: [lvrPermissionGuard(['Clients.Edit', 'Clients.Edit.PhaseOneOnly'])],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								genders: catchErrorOfResolve(genderResolver),
								counties: catchErrorOfResolve(countiesResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [provideGenderApi, provideCategoryApi, provideUploadApi],
						},
						{
							path: 'client/:id/assignments',
							component: ContactView,
							data: {
								recordType: RecordType.CLIENT,
							},
							// restrictedClientGuard is already applied to every child of the Desk route via
							// `canActivateChild` above, so it is intentionally not repeated here.
							canActivate: [lvrPermissionGuard(['Assignments.Read', 'Assignments.Read.PhaseOneOnly'])],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								user: catchErrorOfResolve(userResolver),
							},
							providers: [
								provideClientApi,
								provideUserApi,
								provideAdditionalAssignmentApi,
								provideUploadApi,
								provideSponsorApi,
							],
						},
						{
							path: 'client/:id/assignments/add',
							loadComponent: () => CreateAssignment,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								restrictedClientGuard,
								lvrPermissionGuard(['Assignments.Create', 'Assignments.Create.PhaseOneOnly']),
							],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								assignment: catchErrorOfResolve(activeAssignmentResolver),
								disabilityKindsPage: catchErrorOfResolve(disabilityKindsResolver),
								typesOfCare: catchErrorOfResolve(typesOfCareResolver),
								caseGroups: catchErrorOfResolve(caseGroupsResolver),
								institutions: catchErrorOfResolve(personTypeInstitutionsResolver),
							},
							providers: [
								provideClientApi,
								provideDisabilityTypeApi,
								provideCategoryApi,
								provideUploadApi,
								provideValidationApi,
							],
						},
						{
							path: 'client/:id/assignments/add-fds',
							loadComponent: () => CreateFdsAssignment,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Assignments.Create')],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								disabilityKinds: catchErrorOfResolve(disabilityKindsResolver),
							},
							providers: [
								provideClientApi,
								provideCategoryApi,
								provideSponsorApi,
								provideDisabilityTypeApi,
								provideServiceOfficeStatementApi,
							],
						},
						{
							path: 'client/:id/assignments/add-additional',
							loadComponent: () => CreateAdditionalAssignment,
							data: {
								recordType: RecordType.CLIENT,
							},
							canMatch: [additionalAssignmentEnabledGuard],
							canActivate: [restrictedClientGuard],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								assignment: catchErrorOfResolve(activeAssignmentResolver),
								disabilityKinds: catchErrorOfResolve(disabilityKindsResolver),
							},
							providers: [
								provideClientApi,
								provideCategoryApi,
								provideSponsorApi,
								provideDisabilityTypeApi,
								provideServiceOfficeStatementApi,
								provideAdditionalAssignmentApi,
								provideUserApi,
								provideUploadApi,
							],
						},
						{
							path: 'client/:id/assignments/:assignmentId',
							loadComponent: () => AssignmentView,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								restrictedClientGuard,
								lvrPermissionGuard(['Assignments.Read', 'Assignments.Read.PhaseOneOnly']),
							],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								user: catchErrorOfResolve(userResolver),
								assignment: catchErrorOfResolve(assignmentResolver),
								assignments: catchErrorOfResolve(assignmentsResolver),
								reports: catchErrorOfResolve(reportsOfAssignmentResolver),
								lekPage: catchErrorOfResolve(leksForAssignmentResolver),
								initiatorsPage: catchErrorOfResolve(personTypeInstitutionsResolver),
							},
							providers: [provideAssignmentApi, provideReportApi, provideLekApi, provideClientApi, provideCategoryApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/additional',
							loadComponent: () => AdditionalAssignmentDetails,
							data: {
								recordType: RecordType.CLIENT,
							},
							canMatch: [additionalAssignmentEnabledGuard],
							canActivate: [restrictedClientGuard],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								user: catchErrorOfResolve(userResolver),
								assignment: catchErrorOfResolve(assignmentResolver),
								reports: catchErrorOfResolve(reportsOfAssignmentResolver),
							},
							providers: [provideClientApi, provideReportApi, provideUserApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/fds',
							loadComponent: () => FdsAssignmentDetails,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								restrictedClientGuard,
								lvrPermissionGuard(['Assignments.Read', 'Assignments.Read.PhaseOneOnly']),
							],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								user: catchErrorOfResolve(userResolver),
								assignment: catchErrorOfResolve(assignmentResolver),
								assignments: catchErrorOfResolve(assignmentsResolver),
								reports: catchErrorOfResolve(reportsOfAssignmentResolver),
								lekPage: catchErrorOfResolve(leksForAssignmentResolver),
							},
							providers: [provideClientApi, provideReportApi, provideLekApi, provideServiceOfficeStatementApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/fds/template',
							loadComponent: () => FdsAssignmentTemplate,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Reports.Read')],
							resolve: {
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignment: catchErrorOfResolve(assignmentResolver),
								user: catchErrorOfResolve(userResolver),
							},
							providers: [provideReportApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/fds/template/:reportId',
							loadComponent: () => FdsAssignmentTemplate,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Reports.Read')],
							resolve: {
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								report: catchErrorOfResolve(reportOfAssignment),
								assignment: catchErrorOfResolve(assignmentResolver),
								user: catchErrorOfResolve(userResolver),
							},
							providers: [provideReportApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/report/impediment/:reportId',
							loadComponent: () => LvrImpedimentReport,
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Reports.Read')],
							resolve: {
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignment: catchErrorOfResolve(assignmentResolver),
								user: catchErrorOfResolve(userResolver),
								documentTemplatePage: catchErrorOfResolve(documentTemplatesResolver),
								report: catchErrorOfResolve(reportOfAssignment),
								impedimentGroups: catchErrorOfResolve(allImpedimentAsGroupsResolver),
								impedimentsOnReportPage: catchErrorOfResolve(impedimentsOfReportResolver),
							},
							providers: [provideReportApi, provideImpedimentApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/report/:reportId',
							loadComponent: () => LvrStartReport,
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Reports.Read')],
							resolve: {
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignment: catchErrorOfResolve(assignmentResolver),
								user: catchErrorOfResolve(userResolver),
								documentTemplatePage: catchErrorOfResolve(documentTemplatesResolver),
								report: catchErrorOfResolve(reportOfAssignment),
								impedimentGroups: catchErrorOfResolve(allImpedimentAsGroupsResolver),
								impedimentsOnReportPage: catchErrorOfResolve(impedimentsOfReportResolver),
							},
							providers: [provideReportApi, provideImpedimentApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/admission-qb-report/:reportId',
							loadComponent: () => LvrAdmissionQbReport,
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Reports.Read')],
							resolve: {
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignment: catchErrorOfResolve(assignmentResolver),
								user: catchErrorOfResolve(userResolver),
								documentTemplatePage: catchErrorOfResolve(documentTemplatesResolver),
								report: catchErrorOfResolve(reportOfAssignment),
							},
							providers: [provideReportApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/end-report/:reportId',
							loadComponent: () => LvrEndReport,
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Reports.Read')],
							resolve: {
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignment: catchErrorOfResolve(assignmentResolver),
								user: catchErrorOfResolve(userResolver),
								documentTemplatePage: catchErrorOfResolve(documentTemplatesResolver),
								report: catchErrorOfResolve(reportOfAssignment),
								impedimentGroups: catchErrorOfResolve(allImpedimentAsGroupsResolver),
								impedimentsOnReportPage: catchErrorOfResolve(impedimentsOfReportResolver),
							},
							providers: [provideReportApi, provideImpedimentApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/end-qb-report/:reportId',
							loadComponent: () => LvrEndQbReport,
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Reports.Read')],
							resolve: {
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignment: catchErrorOfResolve(assignmentResolver),
								user: catchErrorOfResolve(userResolver),
								documentTemplatePage: catchErrorOfResolve(documentTemplatesResolver),
								report: catchErrorOfResolve(reportOfAssignment),
							},
							providers: [provideReportApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/edit',
							loadComponent: () => AssignmentEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								restrictedClientGuard,
								lvrPermissionGuard(['Assignments.Edit', 'Assignments.Edit.PhaseOneOnly']),
							],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								assignmentData: catchErrorOfResolve(assignmentWithMetadataResolver),
								disabilityKindsPage: catchErrorOfResolve(disabilityKindsResolver),
								typesOfCare: catchErrorOfResolve(typesOfCareResolver),
								caseGroups: catchErrorOfResolve(caseGroupsResolver),
								institutions: catchErrorOfResolve(personTypeInstitutionsResolver),
								hasUnfinishedReport: catchErrorOfResolve(assignmentHasUnfinishedReportsResolver),
								endOfCares: catchErrorOfResolve(endOfCaresResolver),
								dateRange: catchErrorOfResolve(dateRangeResolverDueToDate),
								lekPage: catchErrorOfResolve(leksForAssignmentResolver),
							},
							providers: [
								provideDisabilityTypeApi,
								provideCategoryApi,
								provideReportApi,
								provideUploadApi,
								provideLekApi,
								provideValidationApi,
							],
						},
						{
							path: 'client/:id/assignments/:assignmentId/edit-fds',
							loadComponent: () => FdsAssignmentEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Assignments.Edit')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								client: catchErrorOfResolve(clientResolver),
								assignmentWithMetadata: catchErrorOfResolve(assignmentWithMetadataResolver),
								disabilityKindsPage: catchErrorOfResolve(disabilityKindsResolver),
								endOfCares: catchErrorOfResolve(endOfCaresResolver),
							},
							providers: [
								provideDisabilityTypeApi,
								provideValidationApi,
								provideSponsorApi,
								provideCategoryApi,
								provideLegalFoundationApi,
							],
						},
						{
							path: 'client/:id/assignments/:assignmentId/edit-additional',
							loadComponent: () => AdditionalAssignmentEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canMatch: [additionalAssignmentEnabledGuard],
							canActivate: [restrictedClientGuard],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								client: catchErrorOfResolve(clientResolver),
								assignment: catchErrorOfResolve(assignmentResolver),
								activeAssignment: catchErrorOfResolve(activeAssignmentResolver),
								disabilityKinds: catchErrorOfResolve(disabilityKindsResolver),
								dateRange: catchErrorOfResolve(dateRangeResolverDueToDate),
							},
							providers: [provideDisabilityTypeApi, provideUploadApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/move',
							loadComponent: () => AssignmentMove,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('Phases.Transition')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignmentData: catchErrorOfResolve(assignmentChangeResolver),
								reports: catchErrorOfResolve(reportsOfAssignmentResolver),
								careerPage: catchErrorOfResolve(careerPageResolver),
								initiatorsPage: catchErrorOfResolve(personTypeInstitutionsResolver),
								disabilityReport: catchErrorOfResolve(latestDisabilityReportResolver),
							},
							providers: [
								provideValidationApi,
								provideCategoryApi,
								provideDisabilityTypeApi,
								provideReportApi,
								provideImpedimentApi,
								provideCareerApi,
								provideDisabilityProofApi,
							],
						},
						{
							path: 'client/:id/assignments/:assignmentId/additional-move',
							loadComponent: () => AdditionalAssignmentMove,
							data: {
								recordType: RecordType.CLIENT,
							},
							canMatch: [additionalAssignmentEnabledGuard],
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Phases.Transition')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignmentData: catchErrorOfResolve(assignmentChangeResolver),
								reports: catchErrorOfResolve(reportsOfAssignmentResolver),
							},
							providers: [provideValidationApi, provideReportApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/fds-move',
							loadComponent: () => FdsAssignmentMove,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Phases.Transition')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								assignmentData: catchErrorOfResolve(assignmentChangeResolver),
								client: catchErrorOfResolve(clientResolver),
								assignment: catchErrorOfResolve(assignmentResolver),
								assignments: catchErrorOfResolve(assignmentsResolver),
								reports: catchErrorOfResolve(reportsOfAssignmentResolver),
							},
							providers: [provideReportApi, provideValidationApi, provideServiceOfficeStatementApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/contacts/add',
							component: CreateContact,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard(['Contacts.Create', 'Contacts.Create.PhaseOneOnly'])],
							resolve: {
								assignment: catchErrorOfResolve(assignmentResolver),
								typeOfCareId: catchErrorOfResolve(typeOfCareIdByAssignmentResolver),
								contactTypes: catchErrorOfResolve(contactTypesResolver),
								user: catchErrorOfResolve(userResolver),
								client: catchErrorOfResolve(clientResolver),
								dateRange: catchErrorOfResolve(validContactDateRangeResolver),
							},
							providers: [
								provideContactApi,
								provideAssignmentApi,
								provideUserApi,
								provideCategoryApi,
								provideValidationApi,
							],
						},
						{
							path: 'client/:id/assignments/:assignmentId/contacts/:contactId',
							loadComponent: () => ContactDetails,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								lvrPermissionGuard(['Contacts.Read', 'Contacts.Read.Restricted', 'Contacts.Read.PhaseOneOnly']),
							],
							resolve: {
								contact: catchErrorOfResolve(contactResolver),
								contacts: catchErrorOfResolve(contactsResolver),
							},
							providers: [provideContactApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/contacts/:contactId/edit',
							loadComponent: () => ContactEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								lvrPermissionGuard(['Contacts.Edit', 'Contacts.Edit.PhaseOneOnly', 'Contacts.Read.Restricted']),
							],
							resolve: {
								assignment: catchErrorOfResolve(assignmentResolver),
								typeOfCareId: catchErrorOfResolve(typeOfCareIdByAssignmentResolver),
								contactTypes: catchErrorOfResolve(contactTypesResolver),
								user: catchErrorOfResolve(userResolver),
								client: catchErrorOfResolve(clientResolver),
								contact: catchErrorOfResolve(contactResolver),
								dateRange: catchErrorOfResolve(validContactDateRangeResolver),
							},
							providers: [
								provideContactApi,
								provideAssignmentApi,
								provideUserApi,
								provideCategoryApi,
								provideValidationApi,
							],
						},
						{
							path: 'client/:id/assignments/:assignmentId/lek/add',
							component: CreateLek,
							data: {
								recordType: RecordType.CLIENT,
							},

							canActivate: [restrictedClientGuard, lvrPermissionGuard('AssistanceResults.Create')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								assignment: catchErrorOfResolve(assignmentResolver),
								lekCategories: catchErrorOfResolve(lekCategoriesResolver),
								sponsorPage: catchErrorOfResolve(lekSponsorResolver),
							},
							providers: [provideCategoryApi, provideLekApi, provideValidationApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/lek/:lekId',
							component: DetailLek,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('AssistanceResults.Read')],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								assignment: catchErrorOfResolve(assignmentResolver),
								lekWithMetadata: catchErrorOfResolve(lekResolver),
								leks: catchErrorOfResolve(leksForAssignmentResolver),
								range: catchErrorOfResolve(validContactDateRangeResolver),
							},
							providers: [provideCategoryApi, provideLekApi, provideValidationApi],
						},
						{
							path: 'client/:id/assignments/:assignmentId/lek/:lekId/edit',
							component: EditLek,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								restrictedClientGuard,
								lvrPermissionGuard(['AssistanceResults.Edit', 'AssistanceResults.Edit.Restricted']),
							],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								assignmentId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('assignmentId')!),
								lekWithMetadata: catchErrorOfResolve(lekResolver),
								lekCategories: catchErrorOfResolve(lekCategoriesResolver),
								sponsorPage: catchErrorOfResolve(lekSponsorResolver),
							},
							providers: [provideCategoryApi, provideLekApi, provideValidationApi],
						},
						{
							path: 'client/:id/relatives',
							component: ClientRelatives,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('ClientEnvironments.Read')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								relatives: catchErrorOfResolve(relativesResolver),
								client: catchErrorOfResolve(clientResolver),
							},
							providers: [provideClientApi],
						},
						{
							path: 'client/:id/relatives/add',
							component: ClientRelativesCreate,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('ClientEnvironments.Create')],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
								genders: catchErrorOfResolve(genderResolver),
								categoryPersonTypes: catchErrorOfResolve(categoryPersonCategoriesResolver),
							},
							providers: [provideCategoryApi, provideGenderApi],
						},
						{
							path: 'client/:id/relatives/:relativeId',
							component: ClientRelativesDetail,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('ClientEnvironments.Read')],
							resolve: {
								relative: catchErrorOfResolve(relativeResolver),
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								relativeNeighbors: catchErrorOfResolve(relativeNeighborsResolver),
							},
						},
						{
							path: 'client/:id/relatives/:relativeId/edit',
							component: ClientRelativesEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('ClientEnvironments.Edit')],
							resolve: {
								relative: catchErrorOfResolve(relativeResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
								genders: catchErrorOfResolve(genderResolver),
								categoryPersonTypes: catchErrorOfResolve(categoryPersonCategoriesResolver),
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
							},
							providers: [provideCategoryApi, provideGenderApi],
						},
						{
							path: 'client/:id/disabilities',
							component: ClientDisabilities,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard(['Documents.DisabilityReport.Read', 'Clients.Read.Restricted'])],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
								proofs: catchErrorOfResolve(disabilityProofsResolver),
								disabilityKinds: catchErrorOfResolve(disabilityKindsResolver),
							},
							providers: [provideDisabilityProofApi, provideDisabilityTypeApi],
						},
						{
							path: 'client/:id/disabilities/proofs/create',
							component: DisabilityProofCreate,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Documents.DisabilityReport.Create')],
							resolve: {
								status: catchErrorOfResolve(disabilityStatusResolver),
								client: catchErrorOfResolve(clientResolver),
								proofs: catchErrorOfResolve(disabilityProofsResolver),
							},
							providers: [provideDisabilityProofApi, provideClientApi],
						},
						{
							path: 'client/:id/disabilities/proofs/:disabilityProofId',
							component: DisabilityProofDetail,
							data: {
								recordType: RecordType.CLIENT,
								reuseRoute: false,
							},
							canActivate: [lvrPermissionGuard(['Documents.DisabilityReport.Read', 'Clients.Read.Restricted'])],
							resolve: {
								proof: catchErrorOfResolve(disabilityProofResolver),
								proofNeighbors: catchErrorOfResolve(disabilityProofNeighborsResolver),
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')!),
							},
							providers: [provideDisabilityProofApi],
						},
						{
							path: 'client/:id/disabilities/proofs/:disabilityProofId/edit',
							component: DisabilityProofEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('Documents.DisabilityReport.Edit')],
							resolve: {
								proof: catchErrorOfResolve(disabilityProofResolver),
								proofs: catchErrorOfResolve(disabilityProofsResolver),
								status: catchErrorOfResolve(disabilityStatusResolver),
								client: catchErrorOfResolve(clientResolver),
							},
							providers: [provideDisabilityProofApi],
						},
						{
							path: 'client/:id/disabilities/type/add',
							component: CreateDisabilityType,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [restrictedClientGuard, lvrPermissionGuard('Documents.DisabilityKind.Create')],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								disabilityTypes: catchErrorOfResolve(disabilityTypesResolver),
								assignment: catchErrorOfResolve(activeAssignmentResolver),
							},
							providers: [provideDisabilityTypeApi, provideClientApi],
						},
						{
							path: 'client/:id/disabilities/type/:disabilityTypeId',
							component: DisabilityTypeItemDetails,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard(['Documents.DisabilityKind.Read', 'Clients.Read.Restricted'])],
							resolve: {
								disabilityType: catchErrorOfResolve(disabilityKindResolver),
								kindNeighbors: catchErrorOfResolve(disabilityKindNeighborsResolver),
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')),
							},
							providers: [provideDisabilityTypeApi],
						},
						{
							path: 'client/:id/disabilities/type/:disabilityTypeId/edit',
							component: DisabilityTypeEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('Documents.DisabilityKind.Edit')],
							resolve: {
								type: catchErrorOfResolve(disabilityKindResolver),
								types: catchErrorOfResolve(disabilityTypesResolver),
								client: catchErrorOfResolve(clientResolver),
								assignment: catchErrorOfResolve(activeAssignmentResolver),
							},
							providers: [provideDisabilityTypeApi],
						},
						{
							path: 'client/:id/career',
							component: ClientCareer,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('Careers.Read')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')),
								clientName: catchErrorOfResolve(clientNameResolver),
								career: catchErrorOfResolve(careerPageResolver),
								client: catchErrorOfResolve(clientResolver),
							},
							providers: [provideCareerApi],
						},
						{
							path: 'client/:id/career/add',
							component: CareerCreate,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('Careers.Create')],
							resolve: {
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')),
								clientName: catchErrorOfResolve(clientNameResolver),
								participationStatus: catchErrorOfResolve(participationStatusResolver),
								socialSecurityStatus: catchErrorOfResolve(socialSecurityStatusResolver),
								career: catchErrorOfResolve(careerPageResolver),
							},
							providers: [provideCareerApi, provideInstitutionApi, provideCategoryApi],
						},
						{
							path: 'client/:id/career/:careerId',
							component: CareerDetail,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('Careers.Read')],
							resolve: {
								careerPage: catchErrorOfResolve(careerPageResolver),
								clientName: catchErrorOfResolve(clientNameResolver),
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')),
							},
							providers: [provideCareerApi],
						},
						{
							path: 'client/:id/career/:careerId/edit',
							component: CareerEdit,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [lvrPermissionGuard('Careers.Edit')],
							resolve: {
								career: catchErrorOfResolve(careerResolver),
								clientId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('id')),
								admissionId: (route: ActivatedRouteSnapshot) => Number(route.queryParamMap.get('admissionId')),
								careerId: (route: ActivatedRouteSnapshot) => Number(route.paramMap.get('careerId')),
								participationStatus: catchErrorOfResolve(participationStatusResolver),
								socialSecurityStatus: catchErrorOfResolve(socialSecurityStatusResolver),
							},
							providers: [provideCareerApi, provideInstitutionApi],
						},
						{
							path: 'client/:id/documents',
							loadComponent: () => DocumentsView,
							data: {
								recordType: RecordType.CLIENT,
							},
							canActivate: [
								lvrPermissionGuard([
									'Documents.General.Read',
									'Documents.Contact.Read',
									'Documents.Assignment.Read',
									'Documents.DisabilityReport.Read',
									'Documents.DisabilityKind.Read',
									'Reports.Read',
								]),
							],
							resolve: {
								client: catchErrorOfResolve(clientResolver),
								clientDocuments: catchErrorOfResolve(clientDocumentsResolver),
							},
							providers: [provideUploadApi],
						},
						{
							path: 'client/:id/documents/templates/:templateId',
							loadComponent: () => LvrTemplateEditorView,
							canActivate: [lvrPermissionGuard('Documents.General.Edit')],
							resolve: {
								clientDocuments: catchErrorOfResolve(clientDocumentsResolver),
							},
							providers: [provideUploadApi],
						},
						{
							path: 'client/:id/documents/:documentId',
							loadComponent: () => LvrDocumentViewer,
							canActivate: [
								lvrPermissionGuard([
									'Documents.General.Read',
									'Documents.Contact.Read',
									'Documents.Assignment.Read',
									'Documents.DisabilityReport.Read',
									'Documents.DisabilityKind.Read',
									'Reports.Read',
								]),
							],
							resolve: {
								document: catchErrorOfResolve(documentResolver),
								documents: catchErrorOfResolve(clientDocumentsResolver),
							},
							providers: [provideUploadApi],
						},
					],
				},
			],
		},
	],
	admin: [
		{
			path: 'admin',
			component: DefaultLayout,
			title: 'Admin',
			canActivate: [MsalGuard, lvrPermissionGuard('Users.Read')],
			children: [
				{
					path: '',
					component: Admin,
					title: 'Admin',
					canActivate: [MsalGuard, lvrPermissionGuard('Users.Read')],
					children: [
						{
							path: 'users',
							component: UserList,
							canActivate: [lvrPermissionGuard(['Users.Create', 'Users.Edit'])],
							resolve: {
								users: catchErrorOfResolve(usersResolver),
							},
							providers: [
								{
									provide: USER_SERVICE,
									useClass: UserApi,
								},
							],
						},
						{
							path: 'users/add',
							component: UserCreate,
							canActivate: [lvrPermissionGuard('Users.Create')],
							resolve: {
								genders: catchErrorOfResolve(genderResolver),
								integrationOffices: catchErrorOfResolve(integrationOfficesResolver),
								roles: catchErrorOfResolve(rolesResolver),
								specializations: catchErrorOfResolve(specializationResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [
								provideGenderApi,
								provideIsoApi,
								{
									provide: ROLE_SERVICE,
									useClass: RoleService,
								},
								{
									provide: SPECIALIZATION_SERVICE,
									useClass: SpecializationService,
								},
								provideCategoryApi,
							],
						},
						{
							path: 'users/:id',
							component: AdminUser,
							canActivate: [lvrPermissionGuard('Users.Read')],
							resolve: {
								user: catchErrorOfResolve(userByIdResolver),
								genders: catchErrorOfResolve(genderResolver),
								roles: catchErrorOfResolve(rolesResolver),
								integrationOffices: catchErrorOfResolve(integrationOfficesResolver),
								specializations: catchErrorOfResolve(specializationResolver),
							},
							providers: [
								{
									provide: USER_SERVICE,
									useClass: UserApi,
								},
								provideGenderApi,
								{
									provide: ROLE_SERVICE,
									useClass: RoleService,
								},
								{
									provide: INTEGRATION_OFFICE_SERVICE,
									useClass: IntegrationServiceOfficeService,
								},
								{
									provide: SPECIALIZATION_SERVICE,
									useClass: SpecializationService,
								},
								providePositionShareApi,
							],
						},
						{
							path: 'users/:id/edit',
							component: AdminUserEdit,
							canActivate: [lvrPermissionGuard('Users.Edit')],
							resolve: {
								user: catchErrorOfResolve(userByIdResolver),
								genders: catchErrorOfResolve(genderResolver),
								roles: catchErrorOfResolve(rolesResolver),
								integrationOffices: catchErrorOfResolve(integrationOfficesResolver),
								specializations: catchErrorOfResolve(specializationResolver),
								contactPointCategories: catchErrorOfResolve(contactPointCategoriesResolver),
							},
							providers: [
								{
									provide: USER_SERVICE,
									useClass: UserApi,
								},
								provideGenderApi,
								{
									provide: ROLE_SERVICE,
									useClass: RoleService,
								},
								{
									provide: INTEGRATION_OFFICE_SERVICE,
									useClass: IntegrationServiceOfficeService,
								},
								{
									provide: SPECIALIZATION_SERVICE,
									useClass: SpecializationService,
								},
								providePositionShareApi,
								{
									provide: NOTIFICATION_SERVICE,
									useClass: NotificationService,
								},
								provideCategoryApi,
							],
						},
					],
				},
			],
		},
	],
};
